import { render, staticRenderFns } from "./TheRecentOrders.vue?vue&type=template&id=1afc5226&scoped=true"
import script from "./TheRecentOrders.vue?vue&type=script&lang=js"
export * from "./TheRecentOrders.vue?vue&type=script&lang=js"
import style0 from "./TheRecentOrders.vue?vue&type=style&index=0&id=1afc5226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc5226",
  null
  
)

export default component.exports